import { MultipleQueriesQuery } from '@algolia/client-search';
import algoliasearch, { SearchClient } from 'algoliasearch/lite'

const { app_id, search_api_key, index_prefix } = window.algoliaShopify.config;

export const searchClient = algoliasearch(app_id, search_api_key)

export const autosuggestSearchClient: SearchClient = {
  ...searchClient,
  search(queries: readonly MultipleQueriesQuery[]) {
    if (queries.every(({ params }) => !params?.query)) {
      return Promise.resolve({
        results: queries.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
        })),
      });
    }

    return searchClient.search(queries);
  },
};

const DEFAULT_PRODUCTS_INDEX_NAME = `${index_prefix}products`
const RECOMMENDED_PRODUCTS = `${index_prefix}products_recommended`
const FEATURED_PRODUCTS_INDEX_NAME = `${index_prefix}products_recently_ordered_count_desc`
const PRICE_LOW_HIGH_PRODUCTS_INDEX_NAME = `${index_prefix}products_price_asc`
const PRICE_HIGH_LOW_PRODUCTS_INDEX_NAME = `${index_prefix}products_price_desc`
const TITLE_A_Z_PRODUCTS_INDEX_NAME = `${index_prefix}products_title_asc`
const TITLE_Z_A_PRODUCTS_INDEX_NAME = `${index_prefix}products_title_desc`
const QUERY_SUGGESTIONS_INDEX_NAME = `${index_prefix}products_query_suggestions`
const ARTICLES_INDEX_NAME = `${index_prefix}articles`
const PAGES_INDEX_NAME = `${index_prefix}pages`
const COLLECTIONS_INDEX_NAME = `${index_prefix}collections`
const BRANDS_INDEX_NAME = `${index_prefix}brand_pages`

export const searchIndexes = {
  COLLECTIONS: COLLECTIONS_INDEX_NAME,
  PRODUCTS: DEFAULT_PRODUCTS_INDEX_NAME,
  RECOMMENDED_PRODUCTS: RECOMMENDED_PRODUCTS,
  FEATURED_PRODUCTS: FEATURED_PRODUCTS_INDEX_NAME,
  SUGGESTIONS: QUERY_SUGGESTIONS_INDEX_NAME,
  ARTICLES: ARTICLES_INDEX_NAME,
  PAGES: PAGES_INDEX_NAME, 
  BRAND_PAGES: BRANDS_INDEX_NAME, 
}

export const productSortOptions = [
  { value: RECOMMENDED_PRODUCTS, label: window.algoliaShopify?.config?.sortOptions?.recommended || "Recommended" },
  { value: TITLE_A_Z_PRODUCTS_INDEX_NAME, label: window.algoliaShopify?.config?.sortOptions?.titleAsc || "Sort A – Z" },
  { value: TITLE_Z_A_PRODUCTS_INDEX_NAME, label: window.algoliaShopify?.config?.sortOptions?.titleDesc || "Sort Z – A" },
  { value: PRICE_HIGH_LOW_PRODUCTS_INDEX_NAME, label: window.algoliaShopify?.config?.sortOptions?.priceHighLow || "Price High – Low" },
  { value: PRICE_LOW_HIGH_PRODUCTS_INDEX_NAME, label: window.algoliaShopify?.config?.sortOptions?.priceLowHigh || "Price Low – High" },
]